import { useController } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';

import { Autocomplete, FormField, Label, TextInput } from '@/modules/forms';

import { Fields } from '../../../constants';
import { DATABASE_ENGINE_SCHEMES } from '../../../utilities';

const name = Fields.DATABASE_TYPE;

const engineOptions = Object.keys(DATABASE_ENGINE_SCHEMES).map(label => ({ value: label }));

export const DatabaseTypeField = () => {
    const { formatMessage } = useIntl();
    const { field } = useController({ name });

    const query = field.value?.toLowerCase() ?? '';

    return (
        <FormField
            name={name}
            htmlFor={name}
            label={
                <Label>
                    <FormattedMessage id={`secret.${name}.label`} />
                </Label>
            }
        >
            {/* virtual={false}: virtual mode renders the clickable options without a role, mirroring only the active one into a hidden listbox. */}
            <Autocomplete
                value={field.value}
                onChange={field.onChange}
                onBlur={field.onBlur}
                options={engineOptions.filter(({ value }) => value.toLowerCase().includes(query))}
                defaultActiveFirstOption={false}
                virtual={false}
            >
                {/* No name: the Autocomplete already binds the field, and a named TextInput would bind it a second time. */}
                <TextInput id={name} placeholder={formatMessage({ id: `secret.${name}.placeholder` })} testId={`${name}-input`} />
            </Autocomplete>
        </FormField>
    );
};
